import InitiativeTimeline from './initiative-timeline-widget-model'
import _ from 'lodash'
import {sectionEndpoint} from 'scoreboard/components/bootslide/object-selector-menu'
import i18n from 'scoreboard/components/i18n'
import createWob from '../create-wob'
import option from 'scoreboard/components/bootslide/menu-icon-option'
import AddDomainObjectEndpoint from 'scoreboard/components/bootslide/add-domain-object-endpoint'
import {ALL_INITIATIVES} from 'scoreboard/initiatives/initiatives-gardener'
import Dataset from 'scoreboard/datasets/model/dataset'
const { ALL_TIME } = Dataset

export default function (bootslideMenu) {
	var label = 'initiatives.gantt'
	return {
		label: i18n.get(label),
		content: option('add-widget-timeline', label),
		contentEndpoint: sectionEndpoint(bootslideMenu, 'initiatives', AddOption)
	}
}

var AddOption = AddDomainObjectEndpoint.extend({
	selectorOptions: function () {
		return _.extend(AddDomainObjectEndpoint.prototype.selectorOptions.apply(this, arguments),
			{ allowAll: true })
	},

	add: function (initiative, organization) {
		let allInits = initiative.id == ALL_INITIATIVES
		var widget = new InitiativeTimeline(
			{
				properties: {
					type: 'initiative-timeline',
					initiativeId: allInits ? null : initiative.id,
					organizationId: allInits? organization.id : null,
					label: allInits ? organization.label : initiative.label,
					showLeftPane: true,
					showFooter: false,
					initialExpansion: 'expandOneLevel',
					calendarId: ALL_TIME
				}
			})

		createWob(this.canvas, widget, { fetchData: true }, this.bootslideMenu)
	}
})
